import { useAuthentication } from 'hooks/authentication';
import { useConversation } from 'hooks/conversation';
import { vendorCommandAsync } from 'services/propel';
import { VendorCommandDataType, VendorCommandValues } from 'services/propel/types';
import { DataDogLogger } from 'utils/dataDog';

export const useVendorCommand = () => {
  const { authenticationState } = useAuthentication();
  const { conversationState } = useConversation();

  const conversationId = authenticationState.propel.conversationId;
  const twilioConversationSid = conversationState.twilio?.conversation.sid ?? '';
  const accessToken = authenticationState.propel.mojoAccessToken;

  const runVendorCommandAsync = async (
    command: VendorCommandValues,
    data?: VendorCommandDataType,
  ) => {
    try {
      return vendorCommandAsync(conversationId, twilioConversationSid, command, accessToken, data);
    } catch (error) {
      DataDogLogger.error(new Error(`Vendor command failed: ${command}`), {
        conversationId,
        command,
        error,
      });
    }
  };

  return { runVendorCommandAsync };
};
